import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

export function Brand({ to = "/", light = false }) {
  return (
    <Link to={to} className="flex items-center gap-2 sm:gap-2.5 group shrink-0" data-testid="brand-logo-link">
      <span className="h-9 w-9 rounded-md bg-emerald-600 grid place-items-center text-white transition-transform duration-200 group-hover:rotate-6">
        <ShieldCheck className="h-5 w-5" />
      </span>
      <span className="leading-tight">
        <span className={`font-display font-extrabold text-lg sm:text-xl tracking-tight block ${light ? "text-white" : "text-slate-900"}`}>
          GrantVerify
        </span>
        <span className={`hidden sm:inline font-mono text-[10px] tracking-[0.18em] uppercase ${light ? "text-slate-400" : "text-slate-500"}`}>
          by Peer Verify LLC
        </span>
      </span>
    </Link>
  );
}
